/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationPricingsSelfWorkerPricesQuery from '../graphql/queries/GetSimulationPricingsSelfWorkerPricesQuery.js';

const useGetSimulationPricingsSelfWorkerPricesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationPricingsSelfWorkerPricesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationPricingsSelfWorkerPrices: R.omit(['__typename'], data?.getSimulationPricingsSelfWorkerPrices_simulation_pricings_self_worker || {})
  };
};

export default useGetSimulationPricingsSelfWorkerPricesQuery;
